<div class="comment" #commentElement *transloco="let t; read:'permit.details.comments'">
    <div class="comment__avatar" #avatarElement [class]="'comment__avatar--' + comment.avatarId">
        {{ comment.initials }}
    </div>
    <div class="comment__content">
        <div class="comment__content__text">{{ comment.text }}</div>
        <div class="comment__content__author" #authorElement [class.author--extended-margin]="hasExtendedMargin">{{ comment.fullName }} {{ comment.created | haDate:"dateTimeStandard" }}</div>
        <div class="comment__content__step" #stepElement *ngIf="comment.step" [innerHTML]="t('stepLabel') + ' ' + t('step.' + comment.step)"></div>
        <div class="comment__content__remove" *ngIf="canDelete" (click)="remove()"></div>
    </div>
    <a *ngIf="comment.questionText" class="comment__info-link"
       href="javascript:void(0)"
       (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
       (click)="toggleTooltipMobile($event)"
       tabindex="0"
       aria-label="Visa fråga"
    >
        <span class="icon-circle-info-solid"></span>
    </a>
    <div *ngIf="tooltipVisible" (click)="toggleTooltipMobile($event)" class="comment__tooltip">
        {{ comment.questionText }}
    </div>
</div>
